<template>
    <div class="user-center-shell">
        <div class="user-info-shell" v-show="user_info_show==1">
            <h2>个人资料修改</h2>
            <div class="user-info-box">
                <div class="info-name">头像：</div>
                <div class="info-content">
                    <div class="user-img handler">
                        <img :src="user_info.head_img_url" alt="" @click.stop="file()">
                        <input type="file" accept="image/*" hidden @change="handleFile" class="hiddenInput"
                               value="点击上传">
                        <div class="user-img-tips handler" @click.stop="file()">更换头像</div>
                    </div>
                </div>
            </div>
            <div class="user-info-box">
                <div class="info-name">姓名：</div>
                <div class="info-content">
                    <div class="user-name">
                        <input type="text" v-model="user_info.nick_name">
                    </div>
                </div>
            </div>
            <div class="user-info-box">
                <div class="info-name">性别：</div>
                <div class="info-content">
                    <div class="user-sex">
                        <div class="sex-box handler" @click.stop="cut_sex(1)">
                            <div class="sex-img">
                                <img src="@/assets/sec-select.png" alt="" v-if="user_info.sex==1">
                            </div>
                            男
                        </div>
                        <div class="sex-box handler" @click.stop="cut_sex(2)">
                            <div class="sex-img">
                                <img src="@/assets/sec-select.png" alt="" v-if="user_info.sex==2">
                            </div>
                            女
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="user-info-box">
                <div class="info-name">修改密码：</div>
                <div class="info-content">
                    <div class="change-btn handler" @click="show_pass_popup">修改密码</div>
                </div>
            </div> -->
            <div class="user-info-box">
                <div class="info-name">联系电话：</div>
                <div class="info-content">
                    <div class="user-tel">{{user_info.user_acc}}</div>
                </div>
            </div>
            <!-- <div class="user-info-box">
                <div class="info-name">身份证号：</div>
                <div class="info-content">
                    <div class="user-idcard">{{encPhone(user_info.user_num)}}</div>
                </div>
            </div>
            <div class="user-info-box">
                <div class="info-name">从业单位：</div>
                <div class="info-content">
                    <el-select placeholder="选择单位" v-model="user_info.company_id">
                        <el-option :label="item.company_name" :value="item.company_id"
                                   v-for="(item,index) in company_list"
                                   :key="index"></el-option>
                    </el-select>
                </div>
            </div> -->
            <el-button class="Btn4" @click.stop="save_info">保存</el-button>

            <div class="hint">
              <div class="">特别说明</div>
              <div class="msg">1、手机号为在线学习必要信息，不可自行修改。如需变更，可联系客服申请：</div>
              <div class="">客服邮箱：172227276@qq.com</div>
              <div class="">客服电话：0731-82229030（工作日 9:00-18:00）</div>
              <div class="">收到申请后 7个工作日内核实处理，并向您反馈结果。</div>
              <div class="msg">2、如需<span>删除全部个人信息</span>，可在学习平台：首页【我的】→【注销账号】→【确认注销】提交申请。注销后 10 个工作日内，我们将对您的个人信息进行删除或匿名化处理。<span>注销不可恢复，请谨慎操作</span>。</div>
            </div>
        </div>
        <div class="password-popup-shell" @click.stop="pass_popup=false" v-if="pass_popup">
            <div class="password-popup-content" @click.stop="">
                <div class="popup-title">修改密码</div>
                <img src="@/assets/colse-icon.png" alt="" class="close-btn handler" @click.stop="pass_popup=false">
                <div class="input-box">
                    <div class="input-name">手机号:</div>
                    <div class="input-shell">
                        <input type="tel" v-model="pass_phone" placeholder="请输入手机号" maxlength="11">
                    </div>
                </div>
                <div class="input-box">
                    <div class="input-name">验证码:</div>
                    <div class="input-shell">
                        <input type="text" v-model="pass_code" placeholder="请输入验证码" maxlength="6">
                        <div class="get-code handler" @click.stop="sendVcode">
                            {{code_tips=='获取验证码'||code_tips=='重新获取'?code_tips: +code_tips+ '秒后重新获取'}}
                        </div>
                    </div>
                </div>
                <div class="input-box">
                    <div class="input-name">新密码:</div>
                    <div class="input-shell">
                        <input type="password" v-model="new_password" placeholder="请输入新密码">
                    </div>
                </div>
                <div class="submit-btn handler" @click.stop="changePassword">确定</div>
            </div>
        </div>
    </div>
</template>

<script>
  import { encPhone } from '../../../utils'
  import NoData from '@/components/no-data.vue'

  export default {
    components: {
      NoData
    },
    data () {
      return {
        code_tips: '获取验证码',
        invoice_detail_show: false,
        user_info_show: 1,
        pass_popup: false,
        pass_phone: '',
        pass_code: '',
        new_password: '',
        show: true,
        timeDown: false,
        verification: '',
        // 查看发票的显示隐藏
        isActive: false,
        // 发票详情的显示隐藏
        danger: false,
        user_info: {
          user_num: ''
        },
        up_user_img: '',
        company_list: [],
        bill_list: [],
        bill_info: {
          'invoice_id': 1,
          'invoice_money': '',
          'invoice_type': '',
          'add_time': '',
          'identifier': '',
          'company_name': '',
          'user_name': '',
          'user_tel': '',
          'user_email': ''
        }
      }
    },
    mounted () {
      this.get_bill_list()
      this.getUserInfo()
      this.get_company_list()
    },
    methods: {
      look_bill_detail (item) {
        this.API.post('user/user_infos-bill_detail', {
          invoice_id: item.invoice_id
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.invoice_detail_show = true
          this.bill_info = res.data.bill_info
        })
      },
      count_down () {
        if (this.timer) {
          window.clearInterval(this.timer)
        }
        this.timer = setInterval(() => {

          this.code_tips--
          if (this.code_tips == 0) {
            this.code_tips = '重新获取'
            clearInterval(this.timer)
          }
        }, 1000)
      },
      show_pass_popup () {
        this.pass_phone = ''
        this.pass_code = ''
        this.new_password = ''
        this.pass_popup = true
      },
      changePassword () {// 修改密码
        if (!this.pass_phone) {
          return this.API.SMessage('请输入手机号')
        }
        if (!this.pass_code) {
          return this.API.SMessage('请输入验证码')
        }
        if (!this.new_password) {
          return this.API.SMessage('请输入密码')
        }
        this.API.post('login/user_acc-forget_pwd', {
          user_acc: this.pass_phone,
          user_pwd: this.new_password,
          veri_code: this.pass_code
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.pass_popup = false
          this.API.SMessage(res.message)
        })
      },
      // 发票列表
      get_bill_list () {
        this.API.post('user/user_infos-bill_list', {}).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.bill_list = res.data.bill_list
        })
      },
      file () {
        this.$el.querySelector('.hiddenInput').click()
      },
      handleFile (e) {
        let _this = this
        let $target = e.target || e.srcElement
        let file = $target.files[0]
        console.log(file)
        let reader = new FileReader()
        reader.onload = (data) => { // 预览
          let res = data.target || data.srcElement
          let imgSrc = res.result
          _this.dealImage(imgSrc, 600, function (base64) {
            imgSrc = base64;
            let fd = new FormData()
            fd.append('token', localStorage.getItem('token'))
            fd.append('file', imgSrc)
            _this.API.post('user/user_infos-upload_img', fd).then((res) => {
              if (res.errno != 0) {
                return _this.API.SMessage(res.message)
              }
              _this.user_info.head_img_url = res.data.file_url
              _this.up_user_img = res.data.file_path
            })
          });
        }
        reader.readAsDataURL(file)
      },
      dealImage(base64, w, callback) {
        var newImage = new Image();
        var quality = 0.3; //压缩系数0-1之间
        newImage.src = base64;
        newImage.setAttribute("crossOrigin", "Anonymous"); //url为外域时需要
        var imgWidth, imgHeight;
        newImage.onload = function () {
          imgWidth = this.width;
          imgHeight = this.height;
          var canvas = document.createElement("canvas");
          var ctx = canvas.getContext("2d");
          if (Math.max(imgWidth, imgHeight) > w) {
            if (imgWidth > imgHeight) {
              canvas.width = w;
              canvas.height = (w * imgHeight) / imgWidth;
            } else {
              canvas.height = w;
              canvas.width = (w * imgWidth) / imgHeight;
            }
          } else {
            canvas.width = imgWidth;
            canvas.height = imgHeight;
            quality = 0.6;
          }
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
          var base64 = canvas.toDataURL("image/jpeg", quality); //压缩语句
          callback(base64);
        };
      },
      encPhone (idcard) {
        return encPhone(idcard)
      },
      countDown ({ days, hours, minutes, seconds }) {
        if (!days && !hours && !minutes && !seconds) {
          this.timeDown = false
        }
      },
      // 点击发送验证码
      sendVcode () {
        if (!this.pass_phone) {
          return this.API.SMessage('请输入手机号')
        }
        if (this.code_tips == '获取验证码' || this.code_tips == '重新获取') {
          this.API.post('login/user_acc-get_msg_code', {
            user_acc: this.pass_phone
          }).then((res) => {
            if (res.errno != 0) {
              return this.API.SMessage(res.message)
            }
            this.code_tips = 60
            this.count_down()
          })
        }
      },
      // 获取用户信息
      getUserInfo () {
        this.API.post('user/user_infos-user_info', {}).then((res) => {
          this.user_info = res.data.user_info
        })
      },
      get_company_list () { // 从业列表
        this.API.post('user/user_infos-company_list', {}).then((res) => {
          this.company_list = res.data.company_list
        })
      },
      cut_sex (val) {
        this.user_info.sex = val
      },
      save_info () { // 保存用户信息
        if (!this.user_info.sex) {
          return this.API.SMessage('请选择性别')
        }
        this.API.post('user/user_infos-edit_user', {
          head_img: this.up_user_img ? this.up_user_img:this.user_info.head_img,
          sex: this.user_info.sex,
          nick_name: this.user_info.nick_name,
          company_id: this.user_info.company_id || 0
        }).then((res) => {
          if (res.errno != 0) {
            return this.API.SMessage(res.message)
          }
          this.$emit('refresh-info')
          this.$message({
            showClose: true,
            message: '保存成功',
            type: 'success',
          })
        })
      }
    },
  }
</script>

<style lang="less" scoped>
    .password-popup-shell {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 0px;
        left: 0px;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, .5);

        .password-popup-content {
            background-color: #fff;
            width: 600px;
            min-height: 300px;
            position: relative;

            .invoice-detail {
                background: #FFFFFF;
                border: 1px solid #E5E5E5;
                padding-bottom: 27px;
            }

            .invoice-info-box {
                display: flex;
                align-items: center;
                margin-top: 28px;
                padding-left: 27px;

                .info-name {
                    font-size: 18px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #666666;
                }

                .info-val {
                    font-size: 18px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #000000;
                }
            }

            .close-btn {
                position: absolute;
                top: 10px;
                right: 10px;
                width: 28px;
                height: 28px;
            }

            .popup-title {
                display: flex;
                align-items: center;
                justify-content: center;
                height: 70px;
                border-bottom: 1px solid #eee;
                font-size: 30px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #000000;
            }

            .input-box {
                display: flex;
                align-items: center;
                padding: 0 30px;
                height: 60px;
                margin: 30px 0 0;
                font-size: 18px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #666666;

                .input-shell {
                    display: flex;
                    align-items: center;
                    width: 430px;
                    height: 50px;
                    border: 1px solid #D2D2D2;
                    border-radius: 5px;
                    margin-left: 10px;

                    input {
                        border: none;
                        height: 100%;
                        width: 100%;
                        padding-left: 10px;
                    }

                    .get-code {
                        width: 130px;
                        min-width: 130px;
                        height: 17px;
                        font-size: 18px;
                        transform: scale(0.8);
                        font-family: PingFang SC;
                        font-weight: 500;
                        color: #666666;
                    }
                }
            }

            .submit-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 120px;
                height: 52px;
                background: #2AA9B5;
                border-radius: 5px;
                font-size: 20px;
                margin: 30px auto;
                font-family: PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
            }
        }
    }

    .user-info-shell {
        padding: 54px;
        > h2 {
          margin-bottom: 50px;
          font-size: 26px;
        }
        .user-info-box {
            display: flex;
            align-items: center;
            margin-bottom: 50px;

            .info-name {
                font-size: 22px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #000000;
                margin-right: 20px;
            }

            .info-content {
                font-size: 22px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #000000;
            }

            .change-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 120px;
                height: 46px;
                border: 1px solid #2AA9B5;
                border-radius: 5px;
                font-size: 20px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #2AA9B5;
            }

            .user-name {
                input {
                    height: 50px;
                    border: none;
                    border-bottom: 1px solid #eee;
                }
            }

            .user-img {
                width: 106px;
                min-width: 106px;
                height: 106px;
                min-height: 106px;
                border: 1px solid #eee;
                border-radius: 50%;

                img {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                }
            }
            .user-img-tips{
                text-align: center;
            }

            .user-sex {
                display: flex;
                align-items: center;
                font-size: 22px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #000000;

                .sex-box {
                    display: flex;
                    align-items: center;
                    margin-right: 20px;
                }

                .sex-img {
                    width: 28px;
                    height: 28px;
                    margin-right: 10px;
                    border: 1px solid #bfbfbf;
                    border-radius: 50%;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }

            .look-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100px;
                height: 46px;
                border: 1px solid #2AA9B5;
                border-radius: 5px;
                font-size: 20px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #2AA9B5;
            }
        }
    }

    .invoice-shell {
        .invoice-title {
            display: flex;
            align-items: center;
            height: 73px;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #000000;
            padding-left: 40px;
            border-bottom: 1px solid #eee;
            margin-bottom: 20px;
        }

        .invoice-list {
            .invoice-box {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 916px;
                height: 120px;
                margin: 0 auto;
                background: #FFFFFF;
                border: 1px solid #E5E5E5;
                border-radius: 5px;
                margin-bottom: 19px;
                padding: 24px 26px;

                .invoice-type {
                    font-size: 20px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #333333;
                    margin-bottom: 20px;
                }

                .invoice-time {
                    font-size: 18px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #999999;
                }

                .invoice-info {
                    display: flex;
                    align-items: center;

                    .invoice-price {
                        font-size: 26px;
                        font-family: Microsoft YaHei;
                        font-weight: bold;
                        color: #D53434;
                        margin-right: 40px;
                    }

                    .invoice-name {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        width: 132px;
                        height: 34px;
                        background: #F1F1F1;
                        border-radius: 5px;
                        font-size: 16px;
                        font-family: Microsoft YaHei;
                        font-weight: 400;
                        color: #999999;
                    }
                }
            }
        }

        .go-back {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 120px;
            height: 52px;
            margin: 20px auto;
            background: #2AA9B5;
            border-radius: 5px;
            font-size: 20px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
        }
    }

    /deep/ .el-radio__input.is-checked .el-radio__inner {
        background-color: #2aa9b5;
    }

    .invoices {
        display: none;
    }

    .div {
        display: flex;
        align-items: center;
        margin-bottom: 50px;
        margin-left: 20px;

        span {
            font-size: 22px;
            font-family: PingFang SC;
            font-weight: 500;
            color: #000000;
        }

        input {
            border: none;
        }

        .img {
            position: relative;
            top: 30px;
            width: 106px;
            height: 106px;
        }

        .Btn {
            border: 1px solid #2aa9b5;
            border-radius: 5px;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #2aa9b5;
        }

        .el-select {
            width: 472px;
            border: 1px solid #d2d2d2;
            border-radius: 5px;
            margin-right: 20px;
        }

        .Btn2 {
            border: 1px solid #2aa9b5;
            border-radius: 5px;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #2aa9b5;
        }

        .Btn3 {
            border: 1px solid #2aa9b5;
            border-radius: 5px;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #2aa9b5;
        }
    }

    .Btn4 {
        width: 120px;
        background: #2aa9b5;
        border-radius: 5px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        margin-left: 20px;
        margin-bottom: 30px;
    }

    .hint {
      padding: 20px 0;
			margin-top: 40px;
			line-height: 36px;
      > div {
        font-size: 20px;
      }
      > .msg {
        margin-top: 10px;
      }
    }
    
    .hint > div > span {
      font-weight: bold;
      font-size: 20px;
    }

    .van-count-down {
        position: relative;
        bottom: 29px;
        left: 335px;
    }

    .Btn1 {
        position: relative;
        left: -100px;
        width: 100px;
        border: 0;
    }

    .el-input {
        width: 430px;
    }

    .Btn5 {
        background: #2aa9b5;
        border-radius: 5px;
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        margin-left: 80px;
    }

    .from {
        margin-bottom: 10px;
        margin-left: 20px;

        .password-title {
            display: flex;
            align-items: center;
            height: 50px;
            border-bottom: 1px solid #eee;
            margin-bottom: 20px;
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #000000;
        }
    }

    .message {
        display: flex;
        align-items: center;
        height: 60px;
        font-size: 20px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #000000;
        margin-bottom: 20px;
        margin-left: 20px;
        border-bottom: 1px solid #eee;
    }


    .particularss {
        height: 800px;
        margin: 0 20px;

        .particulars {
            font-size: 20px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #000000;
            margin-bottom: 20px;
        }

        .specific {
            width: 913px;
            min-height: 348px;
            background: #ffffff;
            border: 1px solid #e5e5e5;

            div {
                margin: 20px;

                span:nth-child(1) {
                    font-size: 18px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #666666;
                    line-height: 44px;
                }

                span {
                    font-size: 18px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #000000;
                }
            }
        }
    }
</style>
